import { useOneTimeCallout } from '@/hooks/use-one-time-callout';

const STORAGE_KEY = 'fimfam-ai:fab-coach-mark-seen';
const SHOW_DELAY_MS = 1500;

/**
 * One-time coach mark for the center AI FAB. Shows once per install, after a
 * short delay so it doesn't compete with initial screen load.
 */
export function useFabCoachMark() {
  const { isCalloutVisible, dismissCallout } = useOneTimeCallout(STORAGE_KEY, SHOW_DELAY_MS);
  return { isCoachMarkVisible: isCalloutVisible, dismissCoachMark: dismissCallout };
}
